/* src/components/meta/Head.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	claim_element,
	detach,
	element,
	init,
	noop,
	query_selector_all,
	safe_not_equal
} from "../../web_modules/svelte/internal.js";

import {
	SNOWPACK_PUBLIC_SITENAME,
	SNOWPACK_PUBLIC_SITEURL
} from "../../_modules/config/index.js";

function create_fragment(ctx) {
	let title_value;
	let meta0;
	let meta1;
	let meta1_content_value;
	let meta2;
	let meta3;
	let meta3_content_value;
	let meta4;
	let meta5;
	let meta6;
	let meta7;
	let meta8;
	document.title = title_value = /*title*/ ctx[0];

	return {
		c() {
			meta0 = element("meta");
			meta1 = element("meta");
			meta2 = element("meta");
			meta3 = element("meta");
			meta4 = element("meta");
			meta5 = element("meta");
			meta6 = element("meta");
			meta7 = element("meta");
			meta8 = element("meta");
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-lhgwhv\"]", document.head);
			meta0 = claim_element(head_nodes, "META", { name: true, content: true });
			meta1 = claim_element(head_nodes, "META", { property: true, content: true });
			meta2 = claim_element(head_nodes, "META", { property: true, content: true });
			meta3 = claim_element(head_nodes, "META", { property: true, content: true });
			meta4 = claim_element(head_nodes, "META", { property: true, content: true });
			meta5 = claim_element(head_nodes, "META", { property: true, content: true });
			meta6 = claim_element(head_nodes, "META", { property: true, content: true });
			meta7 = claim_element(head_nodes, "META", { property: true, content: true });
			meta8 = claim_element(head_nodes, "META", { name: true, content: true });
			head_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(meta0, "name", "description");
			attr(meta0, "content", /*description*/ ctx[3]);
			attr(meta1, "property", "og:url");
			attr(meta1, "content", meta1_content_value = "" + (SNOWPACK_PUBLIC_SITEURL + /*path*/ ctx[1]));
			attr(meta2, "property", "og:title");
			attr(meta2, "content", /*title*/ ctx[0]);
			attr(meta3, "property", "og:type");
			attr(meta3, "content", meta3_content_value = /*home*/ ctx[2] ? "website" : "article");
			attr(meta4, "property", "og:description");
			attr(meta4, "content", /*description*/ ctx[3]);
			attr(meta5, "property", "og:image");
			attr(meta5, "content", /*image*/ ctx[4]);
			attr(meta6, "property", "og:site_name");
			attr(meta6, "content", SNOWPACK_PUBLIC_SITENAME);
			attr(meta7, "property", "og:locale");
			attr(meta7, "content", "ja_JP");
			attr(meta8, "name", "twitter:card");
			attr(meta8, "content", "summary");
		},
		m(target, anchor) {
			append(document.head, meta0);
			append(document.head, meta1);
			append(document.head, meta2);
			append(document.head, meta3);
			append(document.head, meta4);
			append(document.head, meta5);
			append(document.head, meta6);
			append(document.head, meta7);
			append(document.head, meta8);
		},
		p(ctx, [dirty]) {
			if (dirty & /*title*/ 1 && title_value !== (title_value = /*title*/ ctx[0])) {
				document.title = title_value;
			}

			if (dirty & /*description*/ 8) {
				attr(meta0, "content", /*description*/ ctx[3]);
			}

			if (dirty & /*path*/ 2 && meta1_content_value !== (meta1_content_value = "" + (SNOWPACK_PUBLIC_SITEURL + /*path*/ ctx[1]))) {
				attr(meta1, "content", meta1_content_value);
			}

			if (dirty & /*title*/ 1) {
				attr(meta2, "content", /*title*/ ctx[0]);
			}

			if (dirty & /*home*/ 4 && meta3_content_value !== (meta3_content_value = /*home*/ ctx[2] ? "website" : "article")) {
				attr(meta3, "content", meta3_content_value);
			}

			if (dirty & /*description*/ 8) {
				attr(meta4, "content", /*description*/ ctx[3]);
			}

			if (dirty & /*image*/ 16) {
				attr(meta5, "content", /*image*/ ctx[4]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			detach(meta0);
			detach(meta1);
			detach(meta2);
			detach(meta3);
			detach(meta4);
			detach(meta5);
			detach(meta6);
			detach(meta7);
			detach(meta8);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { title } = $$props;
	let { path } = $$props;
	let { home = false } = $$props;
	let { description } = $$props;
	let { image } = $$props;

	$$self.$$set = $$props => {
		if ("title" in $$props) $$invalidate(0, title = $$props.title);
		if ("path" in $$props) $$invalidate(1, path = $$props.path);
		if ("home" in $$props) $$invalidate(2, home = $$props.home);
		if ("description" in $$props) $$invalidate(3, description = $$props.description);
		if ("image" in $$props) $$invalidate(4, image = $$props.image);
	};

	return [title, path, home, description, image];
}

class Head extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			title: 0,
			path: 1,
			home: 2,
			description: 3,
			image: 4
		});
	}
}

export default Head;
//# sourceMappingURL=Head.js.map
